export default function getCategory(store, path) {
  return store.getters['main/categories'].find(
    (item) => item.url === '/' + path.slug
  );
}
